import * as type from '../types/authentication'

export const performRegularLogin = payload => {
    return{
        type: type.REQUEST_REGULAR_LOGIN,
        details: payload
    }
}

export const resetRegularLogin = () => {
    return{
        type: type.RESET_REGULAR_LOGIN
    }
}

export const performGoogleLogin = () => {
    return{
        type: type.REQUEST_GOOGLE_LOGIN,
    }
}

export const resetGoogleLogin = () => {
    return{
        type: type.RESET_GOOGLE_LOGIN
    }
}